module.exports = __webpack_public_path__ + "static/media/table4-forest.6d346339.png";